export const footerMoreLinks = {
  'it-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.it/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.it/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.it/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.it/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.it/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.it/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'it-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.it/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.it/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.it/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.it/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.it/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.it/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'it-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.it/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.it/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.it/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.it/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.it/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.it/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'it-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.it/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.it/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.it/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.it/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.it/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.it/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'it-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.it/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.it/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.it/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.it/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.it/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.it/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'it-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://www.wingie.it/contact/' },
        // { title: 'Domande frequenti', href: 'https://www.wingie.it/faq/' },

        { title: 'Chi siamo', href: 'https://www.wingie.it/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://www.wingie.it/terms-and-conditions/' },
        { title: 'I nostri premi', href: 'https://www.wingie.it/awards/' },
      ],
    },
  ],
  'it-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.it/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.it/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://www.wingie.it/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.it/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.it/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://www.wingie.it/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'it-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.it/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.it/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://www.wingie.it/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.it/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.it/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.it/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'it-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://www.wingie.it/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.it/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://www.wingie.it/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.it/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.it/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.it/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'it-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.it/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.it/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://www.wingie.it/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.it/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.it/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.it/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'it-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.it/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.it/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://www.wingie.it/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.it/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.it/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://www.wingie.it/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'it-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://www.wingie.it/uz/contact/', title: 'Aloqa' },
        // { href: 'https://www.wingie.it/uz/faq/', title: "Tez-tez so'raladigan savollar" },

        { href: 'https://www.wingie.it/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.it/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.it/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.it/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'it-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.it/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.it/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://www.wingie.it/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.it/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.it/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.it/sr/awards/', title: 'Наша признања' },
      ],
    },
  ],
  'it-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.it/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.it/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://www.wingie.it/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.it/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.it/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.it/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'it-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.it/tg/contact/', title: 'Алоқа' },
        // { href: 'https://www.wingie.it/tg/faq/', title: 'Саволҳои зуд-зуд пурсида мешаванда' },

        { href: 'https://www.wingie.it/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.it/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.it/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.it/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'it-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.it/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.it/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://www.wingie.it/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.it/kk/privacy/', title: 'Құпиялық' },
        { href: 'https://www.wingie.it/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.it/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'it-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.it/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.it/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://www.wingie.it/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.it/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.it/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://www.wingie.it/nl/awards/', title: 'Onze awards' },
      ],
    },
  ],
  'it-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.it/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.it/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.it/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.it/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.it/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.it/ja/awards/' },
      ],
    },
  ],
  'it-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.it/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.it/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.it/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.it/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.it/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.it/zh/awards/' },
      ],
    },
  ],
  'it-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.it/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.it/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.it/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.it/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.it/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.it/ko/awards/' },
      ],
    },
  ],
  'it-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.it/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.it/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.it/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.it/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.it/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.it/hi/awards/' },
      ],
    },
  ],
  'it-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.it/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.it/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.it/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.it/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.it/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.it/ta/awards/' },
      ],
    },
  ],
  'it-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.it/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.it/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.it/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.it/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.it/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.it/th/awards/' },
      ],
    },
  ],
  'it-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.it/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.it/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.it/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.it/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.it/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.it/ur/awards/' },
      ],
    },
  ],
  'it-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.it/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.it/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.it/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.it/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.it/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.it/ka/awards/' },
      ],
    },
  ],
}
